<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ltWyUj/tc-custom/9781488063275.jpg?1740433936773" alt="This image is the cover for the book All He Wants for Christmas, The Sterling Wives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All He Wants for Christmas, The Sterling Wives
      </h1>
      <p class="bookDescription body article font2">
        <b>A holiday rendezvous leads to unexpected attraction… </b><b><i>for his brother’s widow.</i></b><br/><br/>For months, real estate developer Andrew Sterling has been laser focused on destroying Sterling Enterprises and bringing down his brother. But Johnathan’s sudden death changes everything—especially when Andrew learns his brother’s widow is pregnant. Andrew has never really seen Miranda Sterling…until now. As they get closer, he must fight the forbidden feelings that threaten more than his bottom line…<br/><br/><b>From Harlequin Desire: Luxury, scandal, desire—welcome to the lives of the American elite.<br/><br/>The Sterling Wives</b><br/>Book 1: <i>Once Forbidden, Twice Tempted</i><br/>Book 2: <i><i>High Society Secrets</i></i><br/>Book 3: <i><i>All He Wants for Christmas</i></i><br/> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Booth
      </h2>
      
      <p class="authorDescription body article">Karen Booth is a Midwestern girl transplanted in the South, raised on &#39;80s music and way too many readings of &ldquo;Forever&rdquo; by Judy Blume. Married to her real-life Jake Ryan, she has two amazing kids with epic hair, a very bratty cat, and loves getting up before dawn to write romance. With plenty of sparks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?706824c2